/// <reference path="onTouchMove.js" />
require('./index.html');
require('es6-promise').polyfill();
require('angular-material');
require('angular-chart.js'); // Will be downloaded in "node_modules"
require('angular-ui-router');
require('angular-messages'); // Will be downloaded in "node_modules"
require('angular-cookies');
require('angular-material-data-table'); // Will be downloaded in "node_modules"
require('angular-ui-mask');
require('lodash');
require('angulartics'); // Will be downloaded in "node_modules"
require('angulartics-google-analytics'); // Will be downloaded in "node_modules"
global.Authentication = require('./core/authentication/authentication');
require('./onTouchMove.js');
require('./localization');
require('angular-translate'); // Will be downloaded in "node_modules"
require('./app.module');



/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/app/app.js
 ** module id = 0
 ** module chunks = 0
 **/